import { isUndefined } from './js';
import Log from './log';
import { isLocalhost } from './webClient';

let defaultDomain = isLocalhost ? 'localhost' : '.cgn.it';

export function setCookieDomain(domain) {
  defaultDomain = domain;
}

function createCookieStorage(settings = { domain: defaultDomain }) {
  const doc = settings.document || document;
  return {
    setItem(key, value) {
      const valueStr = encodeURIComponent(value);
      doc.cookie = `${key}=${valueStr}; Domain=${settings.domain}; expires=0; SameSite=None; Secure`;
    },
    getItem(key) {
      try {
        const resArray = doc.cookie.split(';')
          .map((s) => s.trim().split('='))
          .filter(([k, v]) => k === key)
          .map(([k, v]) => decodeURIComponent(v));

        if (resArray.length === 0) return undefined;
        return resArray[0];
      } catch (err) {
        Log.error(err);
        return undefined;
      }
    },
    removeItem(key) {
      doc.cookie = `${key}=; Domain=${settings.domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    },
    keys() {
      return doc.cookie.split(';')
        .map((s) => s.trim().split('='))
        .map(([k, v]) => k);
    },
  };
}

/**
 *
 * @param {string} property a property id
 * @param {object} store storage
 * @param {func} store.getItem data una stringa chiave, restituisce la stringa memorizzata
 * @param {func} store.setItem data una stringa chiave (primo parametro) salva la stringa data (secondo parametro)
 * @param {func} store.removeItem  data una stringa chiave, cancella la striga memorizzata
 * @returns {object} a storage object
 */
export function storage(property, store = window.sessionStorage) {
  const obj = {
    load: () => {
      const data = store.getItem(property);
      if (!data) {
        return null;
      }
      return JSON.parse(data);
    },
    save: (data) => {
      if (isUndefined(data)) store.removeItem(property);
      else store.setItem(property, JSON.stringify(data));
    },
    clear: () => {
      store.removeItem(property);
    },
    keys: () => {
      if (store.keys) return store.keys();
      const result = [];
      for (let i = 0; i < store.length; i++) {
        result.push(store.key(i));
      }
      return result;
    },
  };
  return obj;
}

/**
 * Restituisce uno storage che utilizza il `window.sessionStorage`.
 * @param {string} property proprietà salvata
 * @returns {object} oggetto storage con metodi load, save e clear.
 */
export function sessionStorage(property) {
  return storage(property);
}

/**
 * Restituisce uno storage che utilizza il `window.localStorage`.
 * @param {string} property proprietà salvata
 * @returns {object} oggetto storage con metodi load, save e clear.
 */
export function localStorage(property) {
  return storage(property, window.localStorage);
}

/**
 * Restituisce uno storage che utilizza i `document.cookie`.
 * @param {string} property proprietà salvata
 * @param {object} settings settaggio di salvataggio dei cookie
 * @param {string} settings.domain dominio di salvataggio dei cookie
 * @returns {object} oggetto storage con metodi load, save e clear.
 */
export function cookieStorage(property, settings) {
  return storage(property, createCookieStorage(settings));
}
